import React, { createContext, useContext } from "react";
import AuthContext from "./AuthContext"; // Import AuthContext

// Create Workshop Context
const WorkshopContext = createContext();

// Custom hook for using WorkshopContext
export const useWorkshop = () => {
    return useContext(WorkshopContext);
};

// Workshop Provider Component
export const WorkshopProvider = ({ children }) => {
    const authCtx = useContext(AuthContext); // Get AuthContext
    const workshopId = authCtx?.workshopId; // Extract workshopId
    const loanEnabled = authCtx?.loanEnabled;
    const workshopEnabled = authCtx?.workshopEnabled;

    return (
        <WorkshopContext.Provider value={{ workshopId, loanEnabled, workshopEnabled }}>
            {children}
        </WorkshopContext.Provider>
    );
};
